import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import { httpsCallable } from 'firebase/functions';
import { paymailUrl } from '../../config/fire-conf';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default function NftTransferDialog(props) {
  const userAuthToken = useSelector((state) => state.authReducer.userauthtoken);

  const [loading, setloading] = useState(false);
  const [recipient, setRecipient] = useState('');

  const handleClose = () => {
    props.setdialogState(false);
  };

  const transferNft = async (e) => {
    e.preventDefault();
    setloading(true);

    let tokenObj = props.walletOwnedNfts[props.selectedNftIndex];
    //isMultiple
    try {
      //checking paymail
      if (!validateEmail(recipient) || !recipient.includes(paymailUrl)) {
        setloading(false);

        toast.error('Please enter a valid paymail.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        return null;
      }

      let stasTokenTransferAPI = httpsCallable(
        firebaseFunctions,
        'musicartNftTransfer',
      );
      let res = await stasTokenTransferAPI({
        recipientAddress: recipient.slice(0, recipient.indexOf(paymailUrl)),
        tokenId: tokenObj.tokenId,
        userAuthToken,
        isMultiple: tokenObj.isMultiple,
        nftId: tokenObj.isMultiple && tokenObj.nftId ? tokenObj.nftId : null,
      });

      console.log('res', res);
      if (res && res.data && res.data.status === 'success') {
        toast.success(res.data.msg, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);

        let updatedArr = [...props.walletOwnedNfts];
        updatedArr.splice(props.selectedNftIndex, 1);
        props.setwalletOwnedNfts(updatedArr);
        setRecipient('');
        handleClose();
      } else if (res && res.data && res.data.status === 'error') {
        toast.error(res.data.msg, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
      } else {
        toast.error('An error occured!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
      }
    } catch (err) {
      console.log('err', err, err.message);
      setloading(false);

      toast.error('An error occured!', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <h5
        className="text-lg font-semibold"
        style={{ padding: '18px 24px 10px 24px' }}
      >
        Transfer NFT to another owner
      </h5>
      <div className="dialog-close-medium">
        <button
          className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
          type="button"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <form className="bg-blueGray-100" onSubmit={transferNft}>
        <DialogContent>
          <div>
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Wallet Paymail
            </label>
            <input
              onChange={(e) => {
                setRecipient(e.target.value);
              }}
              type="text"
              value={recipient}
              placeholder="Enter wallet paymail"
              required
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
            />
          </div>
        </DialogContent>
        <DialogActions
          style={{
            marginTop: 10,
            height: 50,
          }}
        >
          <div
            style={{
              minWidth: 100,
              textAlign: 'center',
            }}
          >
            {(() => {
              if (loading) {
                return (
                  <div className="flex justify-center	w-full">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                );
              } else {
                return (
                  <button
                    className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                    type="submit"
                  >
                    Transfer
                  </button>
                );
              }
            })()}
          </div>
        </DialogActions>
      </form>
    </Dialog>
  );
}
